function CoordMapType(tileSize, minZoom, maxZoom, name, alt) {
    this.tileCache = {}

    this.tileSize = tileSize || new google.maps.Size(256, 256)
    this.maxZoom = maxZoom || 11
    this.minZoom = minZoom || 9
    this.name = name || 'Tile #s'
    this.alt = alt || 'Tile Coordinate Map Type'
}
//Clear cache when we start a new map
CoordMapType.prototype.clearCache = function() {
    this.tileCache = {}
}
CoordMapType.prototype.getTile = function(coord, zoom, ownerDocument) {
    //We should add a loc_id and tourid to the cache
    //to swap easily between locations/tours
    //since we dont current account for that
    var id = 'id' + coord.x + coord.y + zoom

    if (id in this.tileCache) {
        return this.tileCache[id]
    }

    var img = ownerDocument.createElement('img')

    img.src = this.CustomGetTileUrl(coord, zoom)
    img.style.width = this.tileSize.width + 'px'
    img.style.height = this.tileSize.height + 'px'
    img.alt = 'Map tile for experience map.'
    img.id = id

    this.tileCache[id] = img

    return img
}

export default CoordMapType
